// Helpers for bridging angular and react
import ngModule from './ngmodule';
export default ngModule.name;
export * from './injector';
